import { ChartConfig } from '../components/MetricChart'

export const DEDICATED_METRIC_CONFIG: ChartConfig[] = [
  {
    name: 'Duration',
    unit: 's',
    yAxisScaleType: 'log',
    logBase: 'base2',
    queries: [
      {
        name: '999',
        promql: `histogram_quantile(0.999, sum(rate(tidb_server_handle_query_duration_seconds_bucket{k8s_cluster="", {label_cluster_id}, {label_instance_name}}[2m])) by (le))`,
        type: 'line'
      },
      {
        name: '99',
        promql: `histogram_quantile(0.99, sum(rate(tidb_server_handle_query_duration_seconds_bucket{k8s_cluster="", {label_cluster_id}, {label_instance_name}}[2m])) by (le))`,
        type: 'line'
      },
      {
        name: '95',
        promql: `histogram_quantile(0.95, sum(rate(tidb_server_handle_query_duration_seconds_bucket{k8s_cluster="", {label_cluster_id}, {label_instance_name}}[2m])) by (le))`,
        type: 'line'
      },
      {
        name: '80',
        promql: `histogram_quantile(0.8, sum(rate(tidb_server_handle_query_duration_seconds_bucket{k8s_cluster="", {label_cluster_id}, {label_instance_name}}[2m])) by (le))`,
        type: 'line'
      }
    ]
  },
  {
    name: 'QPS',
    unit: 'short',
    queries: [
      {
        name: 'Total',
        promql: `sum(rate(tidb_executor_statement_total{k8s_cluster="", {label_cluster_id}}[2m]))`,
        type: 'line'
      },
      {
        name: '{type}',
        promql: `sum(rate(tidb_executor_statement_total{k8s_cluster="", {label_cluster_id}}[2m])) by (type)`,
        type: 'line'
      }
    ]
  },
  {
    name: 'TiDB CPU',
    unit: 'percentunit',
    queries: [
      {
        name: '{instance}',
        promql: `irate(process_cpu_seconds_total{k8s_cluster="", {label_cluster_id}, {label_instance_name}, component="tidb"}[2m])`,
        type: 'line'
      }
    ]
  },
  {
    name: 'TiDB Memory',
    unit: 'bytes',
    queries: [
      {
        name: '{instance}',
        promql: `process_resident_memory_bytes{k8s_cluster="", {label_cluster_id}, {label_instance_name}, component="tidb"}`,
        type: 'line'
      }
    ]
  },
  {
    name: 'TiKV CPU',
    unit: 'percentunit',
    queries: [
      {
        name: '{instance}',
        promql: `sum(rate(process_cpu_seconds_total{k8s_cluster="", {label_cluster_id}, {label_instance_name}, component=~".*tikv"}[2m])) by (instance)`,
        type: 'line'
      }
    ]
  },
  {
    name: 'TiKV Memory',
    unit: 'bytes',
    queries: [
      {
        name: '{instance}',
        promql: `sum(process_resident_memory_bytes{k8s_cluster="", {label_cluster_id}, {label_instance_name}, component=~".*tikv"}) by (instance)`,
        type: 'line'
      }
    ]
  }
]

export const PREMIUM_METRIC_CONFIG: ChartConfig[] = [
  {
    name: 'Request Units per Second',
    unit: 'short',
    queries: [
      {
        name: 'Total RU per second',
        promql: `(sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_tidb_cluster_id}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_tidb_cluster_id}}[1m])) or vector(0))`,
        type: 'line'
      },
      {
        name: 'AVG RU/s',
        promql: `avg_over_time(((sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_tidb_cluster_id}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_tidb_cluster_id}}[1m])) or vector(0)))[$__range:$__rate_interval] @ end())`,
        type: 'line'
      }
    ]
  },
  {
    name: 'Used Storage Size',
    queries: [
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id) (tikv_store_size_bytes{{label_tidb_cluster_id}, type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based storage',
        type: 'line'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id) (tikv_store_size_bytes{{label_tidb_cluster_id}, type="tiflash_used"}))[$__rate_interval]) or vector(0)',
        name: 'Columnar storage',
        type: 'line'
      }
    ],
    unit: 'bytes'
  },
  {
    name: 'Query Per Second',
    queries: [
      {
        promql:
          '(sum(rate(tidb_executor_statement_total{{label_tidb_cluster_id}}[$__rate_interval])) or vector(0))',
        name: 'All',
        type: 'line'
      },
      {
        promql:
          'sum(rate(tidb_executor_statement_total{{label_tidb_cluster_id}}[$__rate_interval])) by (type)',
        name: '{type}',
        type: 'line'
      }
    ],
    unit: 'short'
  },
  {
    name: 'Query Duration',
    yAxisScaleType: 'log',
    logBase: 'base2',
    queries: [
      {
        promql:
          '(sum(rate(tidb_server_handle_query_duration_seconds_sum{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) / sum(rate(tidb_server_handle_query_duration_seconds_count{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) or vector(0))',
        name: 'avg',
        type: 'line'
      },
      {
        promql:
          'histogram_quantile(0.99, sum(rate(tidb_server_handle_query_duration_seconds_bucket{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) by (le))',
        name: '99',
        type: 'line'
      },
      {
        promql:
          'sum(rate(tidb_server_handle_query_duration_seconds_sum{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) by (sql_type) / sum(rate(tidb_server_handle_query_duration_seconds_count{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) by (sql_type)',
        name: 'avg-{sql_type}',
        type: 'line'
      },
      {
        promql:
          'histogram_quantile(0.99, sum(rate(tidb_server_handle_query_duration_seconds_bucket{{label_tidb_cluster_id}, sql_type!="internal"}[$__rate_interval])) by (le,sql_type))',
        name: '99-{sql_type}',
        type: 'line'
      }
    ],
    unit: 's'
  }
]

export const ESSENTIAL_METRIC_CONFIG: ChartConfig[] = [
  {
    name: 'Capacity vs Usage (RU/s)',
    unit: 'short',
    queries: [
      {
        promql:
          'avg(serverless_metering_rcu_provisioned_capacity{{label_cluster_id}}) or last_over_time(avg(serverless_metering_rcu_provisioned_capacity{{label_cluster_id}})[5m]) or vector(0)',
        name: 'Provisioned capacity (RCU)',
        type: 'line'
      },
      {
        promql:
          '(sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(gateway_connection_flow_bytes_sum{namespace="tidb-admin",direction="out", {label_serverless_keyspace_id}}[1m])/(1024)) or vector(0)) + (sum(rate(sum(tikv_worker_load_data_wru_cost_counter{{label_serverless_keyspace_id}})[1m])) or vector(0)) + (sum(increase(sum(export_ru_cost_counter{{label_serverless_keyspace_id}})[120s])/120) or vector(0))',
        name: 'Consumed (RU/s)',
        type: 'line'
      },
      {
        promql:
          'avg_over_time(((sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(gateway_connection_flow_bytes_sum{namespace="tidb-admin",direction="out", {label_serverless_keyspace_id}}[1m])/(1024)) or vector(0)) + (sum(rate(sum(tikv_worker_load_data_wru_cost_counter{{label_serverless_keyspace_id}})[1m])) or vector(0)) + (sum(increase(sum(export_ru_cost_counter{{label_serverless_keyspace_id}})[120s])/120) or vector(0)))[$__range:$__rate_interval] @ end())',
        name: 'AVG RU/s',
        type: 'line'
      }
    ]
  },
  {
    name: 'Used Storage Size',
    queries: [
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based storage',
        type: 'line'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id) (tikv_store_size_bytes{{label_serverless_keyspace_id}, type="tiflash_used"}))[$__rate_interval]) or vector(0)',
        name: 'Columnar storage',
        type: 'line'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, storage_class="standard",type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based Standard Storage',
        type: 'area_stack'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, storage_class="ia",type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based IA Storage',
        type: 'area_stack'
      }
    ],
    unit: 'bytes'
  },
  {
    name: 'Query Per Second',
    queries: [
      {
        promql:
          'sum(rate(tidb_executor_statement_total{{label_cluster_id}}[$__rate_interval])) or vector(0)',
        name: 'All',
        type: 'line'
      }
    ],
    unit: 'short'
  },
  {
    name: 'Query Duration',
    yAxisScaleType: 'log',
    logBase: 'base2',
    queries: [
      {
        promql:
          'sum(rate(tidb_server_handle_query_duration_seconds_sum{{label_cluster_id}, db!="",sql_type!="internal"}[$__rate_interval])) / sum(rate(tidb_server_handle_query_duration_seconds_count{{label_cluster_id}, db!="",sql_type!="internal"}[$__rate_interval])) or vector(0)',
        name: 'Avg',
        type: 'line'
      },
      {
        promql:
          'histogram_quantile(0.99, sum(rate(tidb_server_handle_query_duration_seconds_bucket{{label_cluster_id}, sql_type!="internal"}[1m])) by (vmrange)) or vector(0)',
        name: 'P99',
        type: 'line'
      }
    ],
    unit: 's'
  },
  {
    name: 'Total Connection',
    queries: [
      {
        promql: 'sum(tidb_server_connections{{label_cluster_id}}) or vector(0)',
        name: 'All',
        type: 'line'
      }
    ],
    unit: 'short'
  }
]

export const STARTER_METRIC_CONFIG: ChartConfig[] = [
  {
    name: 'Request Units',
    unit: 'short',
    queries: [
      {
        promql:
          '(sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(gateway_connection_flow_bytes_sum{namespace="tidb-admin",direction="out", {label_serverless_keyspace_id}}[1m])/(1024)) or vector(0)) + (sum(rate(sum(tikv_worker_load_data_wru_cost_counter{{label_serverless_keyspace_id}})[1m])) or vector(0)) + (sum(increase(sum(export_ru_cost_counter{{label_serverless_keyspace_id}})[120s])/120) or vector(0))',
        name: 'Total RU per second',
        type: 'line'
      },
      {
        promql:
          'avg_over_time(((sum(rate(resource_manager_resource_unit_read_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_write_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(resource_manager_resource_unit_sql_layer_request_unit_sum{{label_serverless_keyspace_id_to_name}}[1m])) or vector(0)) + (sum(rate(gateway_connection_flow_bytes_sum{namespace="tidb-admin",direction="out", {label_serverless_keyspace_id}}[1m])/(1024)) or vector(0)) + (sum(rate(sum(tikv_worker_load_data_wru_cost_counter{{label_serverless_keyspace_id}})[1m])) or vector(0)) + (sum(increase(sum(export_ru_cost_counter{{label_serverless_keyspace_id}})[120s])/120) or vector(0)))[$__range:$__rate_interval] @ end())',
        name: 'AVG RU/s',
        type: 'line'
      }
    ]
  },
  {
    name: 'Used Storage Size',
    queries: [
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based storage',
        type: 'line'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id) (tikv_store_size_bytes{{label_serverless_keyspace_id}, type="tiflash_used"}))[$__rate_interval]) or vector(0)',
        name: 'Columnar storage',
        type: 'line'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, storage_class="standard",type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based Standard Storage',
        type: 'area_stack'
      },
      {
        promql:
          'quantile_over_time(0.5, sum(avg by(keyspace_id, region_id, storage_class) (tikv_store_size_bytes{{label_serverless_keyspace_id}, storage_class="ia",type="used"}))[$__rate_interval]) or vector(0)',
        name: 'Row-based IA Storage',
        type: 'area_stack'
      }
    ],
    unit: 'bytes'
  },
  {
    name: 'Query Per Second',
    queries: [
      {
        promql:
          'sum(rate(tidb_executor_statement_total{{label_cluster_id}}[$__rate_interval])) or vector(0)',
        name: 'All',
        type: 'line'
      }
    ],
    unit: 'short'
  },
  {
    name: 'Query Duration',
    yAxisScaleType: 'log',
    logBase: 'base2',
    queries: [
      {
        promql:
          'sum(rate(tidb_server_handle_query_duration_seconds_sum{{label_cluster_id}, db!="",sql_type!="internal"}[$__rate_interval])) / sum(rate(tidb_server_handle_query_duration_seconds_count{{label_cluster_id}, db!="",sql_type!="internal"}[$__rate_interval])) or vector(0)',
        name: 'Avg',
        type: 'line'
      },
      {
        promql:
          'histogram_quantile(0.99, sum(rate(tidb_server_handle_query_duration_seconds_bucket{{label_cluster_id}, sql_type!="internal"}[1m])) by (vmrange)) or vector(0)',
        name: 'P99',
        type: 'line'
      }
    ],
    unit: 's'
  },
  {
    name: 'Total Connection',
    queries: [
      {
        promql: 'sum(tidb_server_connections{{label_cluster_id}}) or vector(0)',
        name: 'All',
        type: 'line'
      }
    ],
    unit: 'short'
  }
]
